<template>
  <div class="newstitle container-fluid">
    <div class="url"><span class="go_home" @click="goHomeFn">Home</span> > <span v-if="pT">{{pT}} ></span> {{cT}}</div>
    <div class="pageTitle">{{cT}}</div>
  </div>
</template>

<script>
export default {
  name: "NewsTitle",
  props:['pT','cT'],
  methods:{
    goHomeFn(){
      this.$router.push("/home").catch(err => {
        err;
      });
    }
  }
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 768px) {
  .newstitle {
    display: none;
  }
}
@media screen and (min-width: 768px) {
  .newstitle {
    .url {
      font-size: 0.18rem;
      color: #cccccc;
      padding: 0.1rem 0 0.05rem 0;
      .go_home{
        cursor: pointer;
        &:hover{
          color: #666;
        }
      }
    }
    .pageTitle {
      font-weight: bold;
      font-size: 0.3rem;
      margin-bottom: 0.3rem;
    }
  }
}
</style>